import { qoursesApi } from '@/api/qourses.tsx'
import { useQuery } from '@tanstack/react-query'
import { PublicMediaGalleryItemEntity } from '../../../qourses-api-client'

export default function useGetCourseMediaGalleryItemsPublic(courseId: string): {
  mediaGalleryItems: PublicMediaGalleryItemEntity[]
  isLoading: boolean
  isEmptyMediaImages: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: mediaGalleryItems,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(
    getCourseMediaGalleryItemsQueryKey(courseId),
    async () => {
      return qoursesApi.coursePublic.coursePublicControllerGetCourseMediaGalleryItemsV1(courseId)
    },
    {
      enabled: !!courseId,
    },
  )

  const isEmpty = !mediaGalleryItems || mediaGalleryItems.length === 0

  return {
    mediaGalleryItems: mediaGalleryItems || [],
    isLoading,
    isEmptyMediaImages: isEmpty,
    isError,
    refetch,
    isRefetching,
  }
}

export const getCourseMediaGalleryItemsQueryKey = (courseId: string) => [
  'public',
  'galleryItems',
  'course',
  courseId,
]
